import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3zm8 -16h-8a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8z","key":"svg-0"}]]

const IconLayoutSidebarRightFilled = createReactComponent('filled', 'layout-sidebar-right-filled', 'LayoutSidebarRightFilled', __iconNode);

export default IconLayoutSidebarRightFilled;